import React, { useState } from 'react'
import CKEditorComponent from '../../../../../../../components/finalForms/ui/inputs/ckEditor/CKEditor';
import Buttons from '../../../../../../../components/ui/button/Buttons';
import { AppIcons } from '../../../../../../../data/appIcons';

 const SynergyDescription = ({synergyId, editsynergy, updatedCommit,closePopup }) => {
  const [tempDescription, setTempDescription] = useState(editsynergy || "");

  const handleSave = () => {
    if (tempDescription.trim() !== editsynergy.trim()) {
      updatedCommit(tempDescription,synergyId);
    }
    closePopup();
  };

  const handleCancel = () => {
    closePopup();
  };

  return (
   <>
      <CKEditorComponent
        onCKEditorChange={(newData) => setTempDescription(newData)}
        data={tempDescription}
      />

      <div className="row mt-2">
        <div className="col-12">
          <div className="form-btn d-flex justify-content-end">
            <Buttons
              buttonTypeClassName="dark-btn"
              onClick={handleCancel}
              buttonText="Cancel"
            />
            <Buttons
              buttonTypeClassName="theme-btn ml-4"
              onClick={handleSave}
              buttonText="Update"
              imagePath={AppIcons.AddIcon}
            />
          </div>
        </div>
      </div>
    </>
  );
};


export default SynergyDescription
